import React, { useEffect } from "react";
import { Box, Grid, Typography, TextField, InputAdornment, IconButton } from "@material-ui/core";

import { SearchIcon, TodayIcon } from "../../../components/icons";
import UpcomingAppointmentsTable from "../../../components/tables/UpcomingAppointmentsTable";

import {
  useAction,
  agencyActions,
  superAdminActions,
  useSelector,
  authSelectors,
} from "../../../state";
import { useRole } from "../../../hooks";
import { TODAY } from "../../../constants";
import { useInputDebounced } from "../../../lib";

import { useStyles } from "./UpcomingAppointmentsPage.styles";

// TODO add types and interfaces
const UpcomingAppointmentsPage = () => {
  const firstName = useSelector(authSelectors.userFirstName);
  const { isFacilityIntake } = useRole();

  const classes = useStyles({ isFacilityIntake });

  const activeEntity = useSelector(authSelectors.activeEntity);
  const view = activeEntity.type === "home_health_agency" ? "agency" : "facility";
  const getAppointments = useAction(agencyActions.getAppointments);
  // TODO refactor into separate component/hooks
  const setSearchQuery = useAction(superAdminActions.setSearchQuery);

  const [searchQuery, debouncedSearchQuery, handleChange] = useInputDebounced("", 250);

  useEffect(() => {
    setSearchQuery(debouncedSearchQuery);
  }, [setSearchQuery, debouncedSearchQuery]);

  useEffect(() => {
    getAppointments(activeEntity.id, view);
  }, [activeEntity.id, getAppointments, view]);

  return (
    <Box>
      <Grid container justifyContent="space-between" component="header" className={classes.header}>
        <Grid item>
          <Grid container direction="column">
            <Grid item className={classes.title}>
              <Typography variant="h3" component="h1">
                Welcome, {firstName}!
              </Typography>
            </Grid>

            {!isFacilityIntake && (
              <Grid item className={classes.searchWrap}>
                <TextField
                  fullWidth
                  id="search"
                  label="Search for caregiver id or name"
                  variant="outlined"
                  value={searchQuery}
                  onChange={handleChange}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton type="submit">
                          <SearchIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            )}
          </Grid>
        </Grid>

        <Grid item>
          <Grid container>
            <Typography variant="h6">
              <TodayIcon /> {TODAY}
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <UpcomingAppointmentsTable />
    </Box>
  );
};

export default React.memo(UpcomingAppointmentsPage);
